import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Button } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { styled } from '@mui/material/styles'
import dayjs from 'dayjs';
import { PAYMENT_METHOD, convertMoney, getOrderId } from '../../../../utils/utils';
import { useAtomValue } from 'jotai';
import { authAtom } from '../../../../actions';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


const StaffReportItem = ({ staff }) => {
    const history = useHistory()
    const auth = useAtomValue(authAtom)



    return (
        <StyledTableRow
            key={staff.id.toString()}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
        >
            <TableCell>{staff.full_name}</TableCell>
            <TableCell align="right">{`${staff.total_lead}`}</TableCell>
            <TableCell align="right">{`${staff.completed_lead}`}</TableCell>
            <TableCell align="right">{staff.order}</TableCell>
            <TableCell align="right">{convertMoney(staff.totalPrice ?? 0, true)}</TableCell>
            <TableCell align="right">{staff.message}</TableCell>
            <TableCell align="right">{convertMoney(staff.comission, true)}</TableCell>
        </StyledTableRow>
    )
}

export default StaffReportItem